const state = () => ({
  cars: [],
  pagination: {
    totalResults: 0,
    totalPages: 1,
    prevPage: 1,
    currentPage: 1,
    nextPage: 1,
    perPage: 20
  },
});

const getters = {
  cars: state => {
    return state.cars;
  },
  carsPagination: state => {
    return state.pagination;
  },
};

const actions = {
  async fetchCars({ commit, state }, { currentPage, perPage } = {}) {
    const { data, headers } = await this.$http.get(`/cars`, {
      params: {
        orderById: 'DESC',
        limit: perPage || state.pagination.perPage,
        page: currentPage || state.pagination.currentPage
      }
    });
    commit("setCars", { data, headers });
  },
  async addCar({ commit }, { car }) {
    const { data } = await this.$http.post(`/cars`, car);
    commit("pushCar", data);
  },
  async removeCar({ commit }, { id }) {
    await this.$http.delete(`/cars/${id}`);
    commit("delCar", id);
  },
};

const mutations = {
  setCars(state, { data, headers }) {
    state.cars = data;
    state.pagination.totalResults = +headers["x-total-results"];
    state.pagination.totalPages = +headers["x-total-pages"];
    state.pagination.prevPage = +headers["x-total-pages"];
    state.pagination.currentPage = +headers["x-current-page"];
    state.pagination.nextPage = +headers["x-next-page"];
    state.pagination.perPage = +headers["x-per-page"];
  },
  pushCar(state, data) {
    state.cars.unshift(data);
  },
  delCar(state, id) {
    state.cars = state.cars.filter(c => c.id != id);
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
